<template>
  <div id="app4recognition">
    <Printer>
      <template v-slot:printContent>
        <div
          class="h3 mb-2"
          style="font-family: Raleway; font-weight:bold"
        >
          Application for Wood Badge Training Recognition
        </div>
        <div class="mb-2" style="font-size:18px;">
          <b>Part 1.</b> To be completed on the last day of the course, certified by
          the course director, and sent to each participant's localcouncil Scout
          executive along with a copy of that participant's Wood Badge ticket.
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-5">
            <div class="row">
              <div class="col-2">
                Name
              </div>
              <div class="col-10 data-field">
                {{ reportInfo.FullName }}
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-2">
                Email
              </div>
              <div class="col-10 data-field">
                {{ reportInfo.EmailAddress }}
              </div>
            </div>
          </div>
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-5">
            <div class="row">
              <div class="col-3">
                Address
              </div>
              <div class="col-9 data-field">
                {{ reportInfo.StreetAddress }}
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-5">
                City, State and Zip
              </div>
              <div class="col-7 data-field">
                {{ reportInfo.CityStateZip }}
              </div>
            </div>
          </div>
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-5">
            <div class="row">
              <div class="col-4">
                Phone: Home
              </div>
              <div class="col-8 data-field" />
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-1">
                Cell
              </div>
              <div class="col-11 data-field">
                {{ reportInfo.PhoneNumber }}
              </div>
            </div>
          </div>
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-4">
            Participant's council name and number
          </div>
          <div class="col-7 data-field">
            {{ reportInfo.CouncilNameAndNumber }}
          </div>
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-2">
            District Name
          </div>
          <div class="col-4 data-field">
            {{ reportInfo.District }}
          </div>
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-7">
            <div class="row">
              <div class="col-4">
                Scouting Position
              </div>
              <div class="col-8 data-field">
                {{ reportInfo.PrimaryScoutingPosition }}
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="row">
              <div class="col-5">
                Unit Number
              </div>
              <div class="col-7 data-field" />
            </div>
          </div>
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-5">
            <div class="row">
              <div class="col-5">
                Course Number
              </div>
              <div class="col-7 data-field">
                {{ reportInfo.CourseName }}
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-4">
                Course Director
              </div>
              <div class="col-8 data-field">
                {{ reportInfo.CourseDirector }}
              </div>
            </div>
          </div>
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-5">
            <div class="row">
              <div class="col-5">
                Course Location(s)
              </div>
              <div class="col-7 data-field">
                {{ reportInfo.Locations }}
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-3">
                Course Dates
              </div>
              <div class="col-9 data-field">
                {{ reportInfo.Dates }}
              </div>
            </div>
          </div>
        </div>
        <div class="mb-2" style="font-size:18px;">
          <b>Part 2.</b> To participant's council training center:
        </div>
        <div class="row">
          <div class="col-1" />
          <div class="col-11" style="font-size:18px;">
            This Wood Badge participant has completed the training phase of the
            course. I attest that the Wood Badge ticket has been completed and
            recommend that the participant be awarded Wood Badge recognition.
          </div>
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-3">
            Certified by Ticket Counselor
          </div>
          <div class="col-8 data-field" />
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-1">
            Date
          </div>
          <div class="col-3 data-field" />
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-3">
            Certified by Course Director
          </div>
          <div class="col-8 data-field" />
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-1">
            Date
          </div>
          <div class="col-3 data-field" />
        </div>
        <div class="mb-2" style="font-size:18px;">
          <b>Part 3.</b> To be completed by the council training chair and Scout
          Executive (or designee) upon participant's completion of the Wood Badge
          ticket.
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-1">
            Date
          </div>
          <div class="col-3 data-field" />
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-1">
            TO:
          </div>
          <div class="col-5">
            Scout Executive, Council Service Center<br>Course Host Council
          </div>
        </div>
        <div class="row data-row">
          <div class="col-2" />
          <div class="col-5" />
        </div>
        <div class="row">
          <div class="col-1" />
          <div class="col-11" style="font-size:18px;">
            This will certify that the above-named participant has completed the
            Wood Badge application of practical training to the satisfaction of the
            council training committee. We request that notice of Wood Badge
            completion be posted in the course records and that Wood Badge items be
            sent to
          </div>
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-11 data-item" />
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-3">
            For awarding on this date:
          </div>
          <div class="col-8 data-field" />
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-3">
            Scout Executive
          </div>
          <div class="col-8 data-field" />
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-3">
            Council and Council No.
          </div>
          <div class="col-8 data-field">
            {{ reportInfo.CouncilNameAndNumber }}
          </div>
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-3">
            Training Committee Chair
          </div>
          <div class="col-8 data-field" />
        </div>
        <div class="mb-2" style="font-size:18px;">
          <b>Part 4.</b> To be completed by the course host council.
        </div>
        <div class="row data-row">
          <div class="col-1" />
          <div class="col-11">
            <input
              style="margin-right: 2px"
              type="checkbox"
            >Beads, woggle, neckerchief, and certificate shipped
            <input
              style="margin-right: 2px; margin-left: 6px"
              type="checkbox"
            >Records posted
          </div>
        </div>
      </template>
    </Printer>
  </div>
</template>

<script>
import reportsApi from '@/services/api/reports.js'
import Printer from '@/components/_main/printer.vue'

export default {
  name: 'ReportApplicationForRecognition',
  components: {
    Printer
  },
  props: {
    scouterKey: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      reportInfo: {}
    }
  },
  mounted: function () {
    reportsApi
      .getApplicationForRecognitionReport(this.$root.courseKey, this.scouterKey)
      .then(response => {
        this.reportInfo = response
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
